import { createFileRoute } from '@tanstack/react-router'
import { SecuritiesReportChunkDetailPage } from '../../../components/pages/SecuritiesReportChunkDetailPage'

export const Route = createFileRoute('/_auth_required/securities-report-chunks/$securitiesReportChunkId')({
  component: SecuritiesReportChunkDetailPage,
})
